import { ReactNode } from 'react';
import { ErrorBoundary } from 'react-error-boundary';

import { JbNavigationWizardMainSection } from '@bjb-gcrm/gcrm-frontend-components';
import { BrTabItems } from 'views/BrTabs/BrTabs';

export function ProfilingSection({
  tabId,
  title,
  isActive,
  onSectionSelect,
  children,
  isProfilingRelevant = true,
}: {
  tabId: BrTabItems;
  title: string;
  isActive: boolean;
  onSectionSelect: () => void;
  children: ReactNode;
  isProfilingRelevant?: boolean;
}): ReactNode {
  return (
    <ErrorBoundary
      fallback={
        <JbNavigationWizardMainSection
          id={tabId}
          title={title}
          subSections={undefined}
          isActive={isActive}
          onSectionSelect={onSectionSelect}
          isLoading={false}
          isProfilingRelevant={isProfilingRelevant}
        />
      }
    >
      {children}
    </ErrorBoundary>
  );
}
